<template>
  <WDatePicker
    :date.sync="selectedOptionValue"
    :label="label"
    range
    :clear-event="clearEvent"
    :outlined="outlined"
    :dense="dense"
    @update:date="setDate"
    @click:clear="onClear"
  />
</template>

<script>

import WDatePicker from '@/components/common/date-picker/index.vue'

export default {
  name: 'DatePickerRangeSelector',
  components: {
    WDatePicker
  },
  props: {
    clearEvent: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Выберите интервал дат'
    },
    onDateChangeEvent: {
      type: String
    },
    remoteDate: {
      type: Array
    },
    outlined: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
  },
  data: () => ({
    selectedOptionValue: null,
  }),
  computed: {
  },
  async  created () {
    if (this.remoteDate) {
      this.selectedOptionValue = this.remoteDate
    }
  },
  methods: {
    setDate () {
      this.$emit(this.onDateChangeEvent, this.selectedOptionValue)
    },
    onClear () {
      this.selectedOptionValue = null
      this.$emit(this.onDateChangeEvent, null)
    },
  }
}
</script>

